import React, { Component } from 'react';
import PropTypes from 'prop-types';

import "./index.scoped.sass";

function PlateList(props) {
    return (
        <div className="list">
            {
                props.listArr.map((v, i) =>
                    <div className="plate" key={v} onClick={() => { props.clickPlate(v); }}>
                        <div className="mdui-chip mdui-color-indigo-400">
                            <span className="mdui-chip-icon mdui-color-indigo-a200">{handleNum(v)[0]}</span>
                            <span className="mdui-chip-title">{handleNum(v)[1]}</span>
                            <span className="mdui-chip-delete"><i className="mdui-icon material-icons" onClick={(e) => { e.stopPropagation(); props.delItem(i); }}>cancel</i></span>
                        </div>
                    </div>,
                )
            }
        </div>
    );
}

PlateList.propTypes = {
    listArr: PropTypes.array.isRequired,
    clickPlate: PropTypes.func.isRequired,
    delItem: PropTypes.func.isRequired,
};


function handleNum(str) {
    return [str.substr(0, 2), str.substr(2)];
}




export default PlateList;